import React from 'react';
import './styles.css';
import CardHelper from "../../helpers";

function CardHighlight(props) {
  return (
    <div className={`card card-highlight ${props.classOutLineFocus}`}>
      <div className={'card-container'}>
        <div className={'preview-container'}>
          {props.cover !== '' &&
          <div
            className='card-cover'
            style={{ backgroundImage: `url(${props.cover})` }}
          />
          }
          {CardHelper.createProgressBar(props.bookmark)}
          {CardHelper.createBadge(props.badges)}
        </div>
      </div>
    </div>
  );
}

export default CardHighlight;



// WEBPACK FOOTER //
// ./src/components/CardNew/cardTypes/CardHighlight/index.js